import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {Component} from 'react';

import Legal from './legal/Legal';
import Info from './info/Info';
import Newsletter from './newsletter/Newsletter';
import Sms from './sms/Sms';
import Social from './social/Social';

import './SiteFooter.less';
import Logo from './logo/Logo';

export default class SiteFooter extends Component {
    static propTypes = {
        /** Custom class name to add to the footer */
        className: PropTypes.string,
        /** All data to display footer */
        data: PropTypes.shape({
            emailWidget: PropTypes.object,
            legal: PropTypes.object,
            logo: PropTypes.object,
            siteInfo: PropTypes.object,
            smsWidget: PropTypes.object,
            social: PropTypes.array,
        }),
        /** Boolean dictating if the footer should always be in mobile mode showing just legal information */
        isMobile: PropTypes.bool,
        /** HomeAway site name */
        site: PropTypes.string
    };

    static defaultProps = {
        isMobile: false,
        site: 'homeaway_us',
    };

    render() {
        const {className, data, isMobile, site} = this.props;

        if (!data) {
            return null;
        }

        const classes = classNames(
            'SiteFooter',
            site,
            className
        );

        return (
            <footer className={classes}>
                <div className="SiteFooter__container">
                    {!isMobile &&
                        <Logo
                            data={data.logo}
                        />
                    }
                    {!isMobile &&
                        <div className="SiteFooter__section SiteFooter__section--spaced hidden-xs">
                            <div className="SiteFooter__widget-container">
                                <Newsletter
                                    data={data.emailWidget}
                                    site={site}
                                />
                                <Sms
                                    data={data.smsWidget}
                                    site={site}
                                />
                            </div>
                            <Info
                                family={data.family}
                                siteInfo={data.siteInfo}
                            />
                        </div>
                    }
                    <div className="SiteFooter__section">
                        <Legal
                            data={data.legal}
                        />
                        {!isMobile &&
                            <Social
                                data={data.social}
                            />
                        }
                    </div>
                </div>
            </footer>
        );
    }
}